import { createSvgIcon } from '@mui/material';
import Styled from "./custom-styled-icon";

export const SortActionArrow = Styled(
    createSvgIcon(
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.22586 3.35999L3.36584 1.5L1.50586 3.35999" stroke="#656669" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M3.36523 10.5V1.5" stroke="#656669" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M6.77539 8.64001L8.63541 10.5L10.4954 8.64001" stroke="#656669" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8.63672 1.5V10.5" stroke="#656669" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        ,
        "SortActionArrow",
    ),
)


export default SortActionArrow;
